import "core-js/modules/es.function.name.js";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { dateFormat } from 'enums';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FranchiseeDetails = function FranchiseeDetails(_ref) {
  var _franchisee$name, _franchisee$address, _franchisee$email, _franchisee$phone, _franchisee$fax, _franchisee$url, _franchisee$mol_type, _franchisee$mol, _franchisee$eik, _franchisee$credit_in, _franchisee$royalties;

  var franchisee = _ref.franchisee;
  return ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u043C\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$name = franchisee === null || franchisee === void 0 ? void 0 : franchisee.name) !== null && _franchisee$name !== void 0 ? _franchisee$name : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0410\u0434\u0440\u0435\u0441"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$address = franchisee === null || franchisee === void 0 ? void 0 : franchisee.address) !== null && _franchisee$address !== void 0 ? _franchisee$address : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u043C\u0435\u0439\u043B"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$email = franchisee === null || franchisee === void 0 ? void 0 : franchisee.email) !== null && _franchisee$email !== void 0 ? _franchisee$email : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041C\u043E\u0431\u0438\u043B\u0435\u043D"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$phone = franchisee === null || franchisee === void 0 ? void 0 : franchisee.phone) !== null && _franchisee$phone !== void 0 ? _franchisee$phone : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0424\u0430\u043A\u0441"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$fax = franchisee === null || franchisee === void 0 ? void 0 : franchisee.fax) !== null && _franchisee$fax !== void 0 ? _franchisee$fax : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u0430\u0439\u0442"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$url = franchisee === null || franchisee === void 0 ? void 0 : franchisee.url) !== null && _franchisee$url !== void 0 ? _franchisee$url : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0422\u0438\u043F \u043C\u043E\u043B"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$mol_type = franchisee === null || franchisee === void 0 ? void 0 : franchisee.mol_type) !== null && _franchisee$mol_type !== void 0 ? _franchisee$mol_type : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041C\u043E\u043B"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$mol = franchisee === null || franchisee === void 0 ? void 0 : franchisee.mol) !== null && _franchisee$mol !== void 0 ? _franchisee$mol : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0415\u0418\u041A"), ___EmotionJSX("p", {
    className: "value"
  }, (_franchisee$eik = franchisee === null || franchisee === void 0 ? void 0 : franchisee.eik) !== null && _franchisee$eik !== void 0 ? _franchisee$eik : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041B\u0438\u0445\u0432\u0435\u043D \u043F\u0440\u043E\u0446."), ___EmotionJSX("p", {
    className: "value"
  }, "".concat((_franchisee$credit_in = franchisee === null || franchisee === void 0 ? void 0 : franchisee.credit_interest_percent) !== null && _franchisee$credit_in !== void 0 ? _franchisee$credit_in : '', "%"))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041A\u043E\u043C\u0438\u0441\u0438\u043E\u043D\u043D\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, "".concat((_franchisee$royalties = franchisee === null || franchisee === void 0 ? void 0 : franchisee.royalties_percent) !== null && _franchisee$royalties !== void 0 ? _franchisee$royalties : '', "%"))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u044A\u0437\u0434\u0430\u0434\u0435\u043D \u043D\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, moment(franchisee === null || franchisee === void 0 ? void 0 : franchisee.created_at).isValid() ? moment(franchisee === null || franchisee === void 0 ? void 0 : franchisee.created_at).format(dateFormat) : 'N/A')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0431\u043D\u043E\u0432\u0435\u043D \u043D\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, moment(franchisee === null || franchisee === void 0 ? void 0 : franchisee.updated_at).isValid() ? moment(franchisee === null || franchisee === void 0 ? void 0 : franchisee.updated_at).format(dateFormat) : 'N/A')));
};

FranchiseeDetails.propTypes = {
  franchisee: PropTypes.object
};
export default FranchiseeDetails;